import { render, staticRenderFns } from "./PTOForm.vue?vue&type=template&id=4ffc1e68&scoped=true&"
import script from "./PTOForm.vue?vue&type=script&lang=js&"
export * from "./PTOForm.vue?vue&type=script&lang=js&"
import style0 from "./PTOForm.vue?vue&type=style&index=0&id=4ffc1e68&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffc1e68",
  null
  
)

export default component.exports